// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"cec43f47","453":"fa53222b"}[chunkId] + ".chunk.js";
};